import { render, staticRenderFns } from "./TwoFaResetSuccess.vue?vue&type=template&id=1edc2a94&scoped=true&lang=html&"
import script from "./TwoFaResetSuccess.vue?vue&type=script&lang=js&"
export * from "./TwoFaResetSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TwoFaResetSuccess.vue?vue&type=style&index=0&id=1edc2a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc2a94",
  null
  
)

export default component.exports